{
    "Accessibility Menu": "Toegankelijkheidsmenu",
    "Reset settings": "Instellingen resetten",
    "Close": "Sluiten",
    "Content Adjustments": "Inhoudsaanpassingen",
    "Adjust Font Size": "Lettergrootte aanpassen",
    "Highlight Title": "Titel markeren",
    "Highlight Links": "Links markeren",
    "Readable Font": "Leesbaar lettertype",
    "Color Adjustments": "Kleur aanpassingen",
    "Dark Contrast": "Donker contrast",
    "Light Contrast": "Licht contrast",
    "High Contrast": "Hoog contrast",
    "High Saturation": "Hoge verzadiging",
    "Low Saturation": "Lage verzadiging",
    "Monochrome": "Monochroom",
    "Protanopia": "Protanopie",
    "Deuteranopia": "Deuteranopie",
    "Tritanopia": "Tritanopie",
    "Visual & Navigation Aids": "Visuele en navigatiehulpmiddelen",
    "Additional Tools": "Extra hulpmiddelen",
    "Reading Guide": "Leesgids",
    "Stop Animations": "Animaties stoppen",
    "Big Cursor": "Grote cursor",
    "Screen Reader": "Schermlezer",
    "Hide Images": "Afbeeldingen verbergen",
    "Image Tooltips": "Afbeeldingstips",
    "Page Structure": "Paginastructuur",
    "Super Focus": "Super Focus",
    "Magnifier": "Vergrotingsglas",
    "Increase Font Size": "Lettergrootte vergroten",
    "Decrease Font Size": "Lettergrootte verkleinen",
    "Letter Spacing": "Letterafstand",
    "Line Height": "Regelhoogte",
    "Font Weight": "Letterdikte",
    "Dyslexia Font": "Dyslexie lettertype",
    "Language": "Taal",
    "Open Accessibility Menu": "Toegankelijkheidsmenu openen",
    "Accessibility Profiles": "Toegankelijkheidsprofielen",
    "Seizure Safe Profile": "Veilig profiel voor aanvallen",
    "Stops animations and reduces color saturation.": "Stopt animaties en verlaagt kleurverzadiging.",
    "Blind Profile": "Profiel voor blinden",
    "Activates the screen reader for auditory navigation.": "Activeert de schermlezer voor auditieve navigatie.",
    "Visually Impaired Profile": "Profiel voor slechtzienden",
    "Enhances contrast and readability for low vision.": "Verbetert contrast en leesbaarheid voor slechtzienden.",
    "ADHD Friendly Profile": "ADHD-vriendelijk profiel",
    "Reduces distractions for better focus.": "Vermindert afleidingen voor betere concentratie.",
    "Cognitive & Learning Profile": "Cognitief en leerprofiel",
    "Helpful tools for reading and comprehension.": "Handige hulpmiddelen voor lezen en begrip.",
    "Motor Impaired Profile": "Profiel voor motorische beperkingen",
    "Optimizes the site for keyboard-only navigation.": "Optimaliseert de site voor puur toetsenbordnavigatie.",
    "Headings": "Koppen",
    "Landmarks": "Oriëntatiepunten",
    "Links": "Links",
    "Focus element": "Element focussen",
    "Visit link": "Link bezoeken"
}
